/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListingStrategy } from '../models/ListingStrategy';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ListingStrategyService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a ListingStrategy resource.
     * Retrieves a ListingStrategy resource.
     * @returns ListingStrategy ListingStrategy resource
     * @throws ApiError
     */
    public getListingStrategy(): CancelablePromise<ListingStrategy> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/listing/strategy',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
